import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlfaIcon } from '@che-ins-ui/icons/AlfaIcon';
import { IngosstrahIcon } from '@che-ins-ui/icons/IngosstrahIcon';
import { RenessansIcon } from '@che-ins-ui/icons/RenessansIcon';
import { ResoIcon } from '@che-ins-ui/icons/ResoIcon';
import { TinkoffIcon } from '@che-ins-ui/icons/TinkoffIcon';
import { useStyles } from './styles';
export const InsuranseCompanies = () => {
    const classes = useStyles();
    return (_jsxs("div", { className: classes.footer, children: [_jsx(IngosstrahIcon, {}), _jsx(AlfaIcon, {}), _jsx(RenessansIcon, {}), _jsx(ResoIcon, {}), _jsx(TinkoffIcon, {})] }));
};
